import { render } from "./OfflineMode.vue?vue&type=template&id=63712f2c&scoped=true"
import script from "./OfflineMode.vue?vue&type=script&lang=js"
export * from "./OfflineMode.vue?vue&type=script&lang=js"

import "./OfflineMode.vue?vue&type=style&index=0&id=63712f2c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63712f2c"]])

export default __exports__